export default __webpack_public_path__ + "static/media/5s.4e540814.svg";